define(function (require) {

    lpTag.WebAgent = lpTag.WebAgent || {};

    var lpUtils = require('utils/lpUtils');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var lpBaseService = require('web-agent-services/BaseService');


    var APPLICATION_TYPE = 'lpMessagingAgentListForTransferService';
    var TIMEOUT = 10000;
    var BASE = lpBaseService;

    var lpMessagingAgentListForTransferService = function () {
        var serviceName = agentLEManager.getCSDSRecord('msgHist') ? "MessagingEngagementsHistory" : "MessagingEngagementsHistoryOnSharedServers";
        BASE.call(this, { serviceName: serviceName });
        this._initializeApiResource();
    };

    lpUtils.extend(lpMessagingAgentListForTransferService, BASE);

    lpMessagingAgentListForTransferService.prototype = new lpBaseService();

    lpMessagingAgentListForTransferService.prototype.applicationType = APPLICATION_TYPE;

    lpMessagingAgentListForTransferService.prototype._initializeApiResource = function () {
        if (!this.apiResourceService) {
            return this.logger.error('cannot create end points for the service, no service end point.');
        }
        this.apiEndPoints = {
            searchMessagingAgentsList: this.createAPIEndPointService('SearchMessagingAgentsList'),
        };
    };

    lpMessagingAgentListForTransferService.prototype.searchMessagingAgentsList = function (reqObj) {
        var skillId = reqObj.skillId ? reqObj.skillId + '' : '-1';

        reqObj.callingFunction = 'SearchMessagingAgentsList';
        reqObj.method = 'POST';
        reqObj.timeout = TIMEOUT;
        reqObj.data = { skillIds: [skillId] };
        reqObj.additionalUrl = this.apiEndPoints.searchMessagingAgentsList.additionalUrl;

        if (reqObj.pollingCallback) {
            this.apiEndPoints.searchMessagingAgentsList.startPolling(reqObj);
            return this.apiEndPoints.searchMessagingAgentsList.stopPolling.bind(this);
        } else {
            this.apiEndPoints.searchMessagingAgentsList.stopPolling();
            this.apiEndPoints.searchMessagingAgentsList.sendRequest(reqObj);
        }
    };

    return lpMessagingAgentListForTransferService;

});
